import api from './api';

const contractorVerificationService = {
  async getMyVerification() {
    const response = await api.get('/contractor-verifications/me');
    return response.data;
  },

  async saveBusinessProfile(data) {
    const response = await api.put('/contractor-verifications/me/business', data);
    return response.data;
  },

  async addDocument(data) {
    const response = await api.post('/contractor-verifications/me/documents', data);
    return response.data;
  },

  async addPortfolioEvidence(data) {
    const response = await api.post('/contractor-verifications/me/portfolio', data);
    return response.data;
  },

  async addReference(data) {
    const response = await api.post('/contractor-verifications/me/references', data);
    return response.data;
  },

  async submit() {
    const response = await api.post('/contractor-verifications/me/submit');
    return response.data;
  },

  async listAdmin(params = {}) {
    const response = await api.get('/contractor-verifications/admin', { params });
    return response.data;
  },

  async getAdmin(id) {
    const response = await api.get(`/contractor-verifications/admin/${id}`);
    return response.data;
  },

  async review(id, data) {
    const response = await api.post(`/contractor-verifications/admin/${id}/review`, data);
    return response.data;
  },

  async assignVerifier(id, data) {
    const response = await api.post(`/contractor-verifications/admin/${id}/assign-verifier`, data);
    return response.data;
  },

  async getEvidencePack(id) {
    const response = await api.get(`/contractor-verifications/admin/${id}/evidence-pack`);
    return response.data;
  },

  async updateEvidence(type, id, data) {
    const response = await api.patch(`/contractor-verifications/admin/evidence/${type}/${id}`, data);
    return response.data;
  },

  async listVerifierAssignments(params = {}) {
    const response = await api.get('/contractor-verifications/verifier/assignments', { params });
    return response.data;
  },

  async getVerifierAssignment(assignmentId) {
    const response = await api.get(`/contractor-verifications/verifier/assignments/${assignmentId}`);
    return response.data;
  },

  async startVerifierAssignment(assignmentId) {
    const response = await api.post(`/contractor-verifications/verifier/assignments/${assignmentId}/start`);
    return response.data;
  },

  async saveRepresentativeCheck(assignmentId, data) {
    const response = await api.put(`/contractor-verifications/verifier/assignments/${assignmentId}/representative-check`, data);
    return response.data;
  },

  async addSiteVisit(assignmentId, data) {
    const response = await api.post(`/contractor-verifications/verifier/assignments/${assignmentId}/site-visits`, data);
    return response.data;
  },

  async updateReferenceCheck(assignmentId, referenceId, data) {
    const response = await api.patch(`/contractor-verifications/verifier/assignments/${assignmentId}/references/${referenceId}`, data);
    return response.data;
  },

  async submitVerifierEvidencePack(assignmentId, data) {
    const response = await api.post(`/contractor-verifications/verifier/assignments/${assignmentId}/submit`, data);
    return response.data;
  },

  // Vetting jobs on offer to this verifier (first to accept gets the file).
  async listMyVettingOffers() {
    const response = await api.get('/contractor-verifications/verifier/offers');
    return response.data;
  },

  async getVettingOffer(offerId) {
    const response = await api.get(`/contractor-verifications/verifier/offers/${offerId}`);
    return response.data;
  },

  async acceptVettingOffer(offerId) {
    const response = await api.post(`/contractor-verifications/verifier/offers/${offerId}/accept`);
    return response.data;
  },

  async declineVettingOffer(offerId) {
    const response = await api.post(`/contractor-verifications/verifier/offers/${offerId}/decline`);
    return response.data;
  }
};

export default contractorVerificationService;
